export default 'M21.03 1 1.53 3.4l.65 5.33v6.55h9.94L2.17 16.5l.8 6.5 19.5-2.4-.64-5.32V8.73h-9.98l9.98-1.23z';